import { Suspense, useEffect } from 'react'
import { useState } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect, HashRouter } from 'react-router-dom'
import { loadConfig, MOBILEAPP_LINK } from './constants/api.config'
// import './scss/style.scss'
//import Login from './views/pages/login/newLogin.jsx'
//import Register from './views/pages/Register/Register.jsx'
import { getUserToken, globalLogoutFunction } from './utils/handleCookie.js'
import DefaultLayout from './layout/DefaultLayout'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import ChangePassword from './views/pages/login/ChangePassword'
import axios from 'axios'
// import { ReactQueryDevtools, ReactQueryDevtoolsPanel } from 'react-query/devtools'
import './index.css'
import { Toaster } from 'react-hot-toast'
import { lazy } from 'react'
import { UserContext } from './Contexts/UserContext'
import { rightBasedMenuFettcher } from './services/login'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import Loader from './components/shared/Loader'
import useBreakpoints from './utils/Breakpoints'

const Login = lazy(() => import('./views/pages/login/newLogin.jsx'))
const Register = lazy(() => import('./views/pages/Register/Register.jsx'))
const ForgotUserID = lazy(() => import('./views/pages/ForgotPages/ForgotUserID'))
const ForgotPassword = lazy(() => import('./views/pages/ForgotPages/ForgotPassword'))
const UpdateUserDetails = lazy(() => import('./views/pages/UpdateUser/UpdateUserDetails'))
const ErrorPage = lazy(() => import("./components/ErrorPage"))
const DataViewWithMap = lazy(() => import('./views/dashboard/NewComponents/DataViewWithMap'))

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (getUserToken() ? <Component {...props} /> : <Redirect to={{ pathname: '/login' }} />)} />
)

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (getUserToken() ? <Redirect to={{ pathname: '/home' }} /> : <Component {...props} />)} />
)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 10,
    },
  },
})

window.NavigationDetails = {}

const App = () => {
  const { isSm } = useBreakpoints() // Use your breakpoints hook
  const [activeSelection, setActiveSelection] = useState(true)
  const [encryptedURL, setEncryptedURL] = useState(true)
  const [loadinFlag, setLoadingFlag] = useState(false)
  const [contextUserData, setContextUserData] = useState({})
  const [showBanner, setShowBanner] = useState(null)
  const history = useHistory()

  async function firstEffect() {
    const localStorageString1 = localStorage.getItem("RNB_LOGGED_IN_USER_DATA")
    const sessionIdString = sessionStorage.getItem("RNB_SESSION_ID")
    const localStorageShowBanner = JSON.parse(localStorage.getItem("showBanner"))

    if (!localStorageString1 || !sessionIdString) {
      globalLogoutFunction()
    } else {
      let loginData = JSON.parse(localStorageString1)
      loginData = { ...loginData, changed: loginData?.changed + 1 }
      let loginData2 = await rightBasedMenuFettcher(loginData?.UserID?.trim(), "DSH", true, loginData)

      if (loginData2) {
        setContextUserData(prev => ({ ...prev, ...loginData2, showBrodCastMessage: false }))
        setShowBanner(localStorageShowBanner)
      }
    }
  }

  useEffect(() => {
    firstEffect()
  }, [])

  // Mobile restriction using your breakpoints hook
  if (isSm) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100vw',
        padding: '20px',
        boxSizing: 'border-box',
        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}>
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '40px 30px',
          maxWidth: '400px',
          width: '100%',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
          textAlign: 'center'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 24px',
            background: '#f0f0f0',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '40px'
          }}>
            📱
          </div>

          <h2 style={{
            margin: '0 0 12px 0',
            fontSize: '24px',
            fontWeight: '600',
            color: '#1a1a1a'
          }}>
            Mobile Access Restricted
          </h2>

          <p style={{
            margin: '0 0 24px 0',
            fontSize: '16px',
            color: '#666',
            lineHeight: '1.5'
          }}>
            This application cannot be accessed from mobile browsers. Please use the <strong>RNBD Mobile App</strong> for mobile access.
          </p>

          <a href={MOBILEAPP_LINK} style={{
            padding: '12px 24px',
            background: '#667eea',
            color: 'white',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            display: 'inline-block'
          }}>
            Download RNBD Mobile App
          </a>
        </div>
      </div>
    )
  }

  return (
    <UserContext.Provider value={{ activeSelection, setActiveSelection, encryptedURL, setEncryptedURL, contextUserData, setContextUserData, showBanner, setShowBanner }}>
      <QueryClientProvider client={queryClient}>
        {/* <ReactQueryDevtoolsPanel isOpen={true}></ReactQueryDevtoolsPanel> */}
        <HashRouter>
          <Toaster />
          <Suspense fallback={<Loader />}>
            <Switch>
              <PublicRoute exact path="/" name="Login Page" component={() => <Login />} />
              <ProtectedRoute
                path="/home"
                component={() => (
                  <>
                    <DefaultLayout loadingFlag={loadinFlag} />
                  </>
                )}
              />
              <ProtectedRoute path="/homeBuilding" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/watchlist" component={() => <DefaultLayout />} />
              <PublicRoute exact path="/login" name="Login Page" component={() => <Login />} />
              <PublicRoute exact path="/signup" name="Signup page" component={() => <Register />} />
              <PublicRoute exact path="/forgotpassword" name="ForgotPassword page" component={() => <ForgotPassword />} />
              <PublicRoute exact path="/forgotuserid" name="ForgotUserid page" component={() => <ForgotUserID />} />
              <ProtectedRoute path="/dashboard" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/buildings" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/datawarehouse" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/details" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/childTable" component={() => <DefaultLayout />} />
              <ProtectedRoute exact path="/changepassword" name="Change password page" component={() => <ChangePassword />} />
              <ProtectedRoute exact path="/updateuserdetails" name="update user deatils page" component={() => <UpdateUserDetails />} />
              <ProtectedRoute path="/directreport" component={() => <DefaultLayout />} />

              <Route
                path="/unauthorized"
                render={() => (
                  <ErrorPage
                    errCode="403 - Unauthorized"
                    errMessage="Oops! You do not have permission to access this page."
                  />
                )}
              />

              <Route path="*" component={() => <ErrorPage errCode={"404 - Page Not Found"} errMessage={"Oops! The page you're looking for doesn't exist."} />} />
            </Switch>
          </Suspense>
        </HashRouter>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </UserContext.Provider>
  )
}

export default App